import Navigation from "../../components/Navigation/Navigation";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation";
import { useState, useEffect } from "react";
import useActions from './acciones'
import useApi from "../../helpers/api";
import { useParams } from "react-router-dom";
import Loader from '../../components/Loader/Loader'
import HtmlEditor from "../../components/HtmlEditor/HtmlEditor";

export default function Asientos() {
  const api = useApi();
  const [template, setTemplate] = useState([]);
  const { id } = useParams();
  const {updateTemplate, loading} = useActions(template);

  useEffect(() => {
    async function getTemplate () {
      const templateResponse = await api.getTemplate(id);
      setTemplate(templateResponse)
    }
    getTemplate()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!!template && !loading ? 
        <>
          <Navigation />
          <SecondaryNavigation title="Asientos" />

          <div className="container-fluid">
            <HtmlEditor
              initialHtml={template.html}
              initialCss={template.css}
              onSave={updateTemplate}
              width={template.ancho}
              height={template.alto}
            />
          </div>
        </>
      :
        <Loader/>
      }
    </>
  );
}
